import { chain } from '@leprecoins/effector';
import { sample } from 'effector';
import { debounce } from 'patronum';
import { createExportReportShiftsModel } from 'features/export-report-shifts';
import { accountTreeModel } from 'entities/account';
import { createShiftReportRegistryModel } from 'entities/shift';

export const shiftRegistryModel = createShiftReportRegistryModel({
	$currencies: accountTreeModel.$currencies,
	$allAccountIds: accountTreeModel.$nodes.map((nodes) => Object.values(nodes).map(({ id }) => id)),
});

const exportReportShiftsModel = createExportReportShiftsModel(shiftRegistryModel);

sample({
	clock: debounce(accountTreeModel.$selectedNodes, 300),
	target: shiftRegistryModel.registryModel.filters.accountIds.setValue,
});

chain(shiftRegistryModel.registryModel.clearFilters, accountTreeModel.clearSelectedNodes);

export const shiftsReportPageModel = {
	shiftRegistryModel,
	exportReportShiftsModel,
};
